module.exports = __webpack_public_path__ + "fi-eu-leaf-998bcf6a7567da096cc612b93adea60c.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-eu-leaf.png
// module id = 83
// module chunks = 0